export default __webpack_public_path__ + "alberta-description.8094d32092f3c2225c6a.svg";